import { render, staticRenderFns } from "./ItemContent.vue?vue&type=template&id=bcb354da&scoped=true"
import script from "./ItemContent.vue?vue&type=script&lang=js"
export * from "./ItemContent.vue?vue&type=script&lang=js"
import style0 from "./ItemContent.vue?vue&type=style&index=0&id=bcb354da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb354da",
  null
  
)

export default component.exports